export enum ReviewersEnum {
    ContentReviewer = "ContentReviewer",
    EUReviewer = "EUReviewer",
    ProofReader = "ProofReader",
}
